import jQuery from 'jquery';

declare var fbq: any;
declare var gtag: any;

export const tdAnalytics: Record<string, any> = {

    _fbPixelId: '',
    _gaTrackingId: '',
    _gaErrors: [],
    _fbErrors: [],

    init: function() {

        //disabled on tdc iframe
        if ( tdAnalytics._inIframe() === true ) {
            return;
        }

        // check the google analytics tracking id
        if ( typeof window.dataLayer !== 'undefined' ) {
            window.dataLayer.forEach( function (element, index, array) {
                if( element[0] === 'config' ) {
                    tdAnalytics._gaTrackingId = element[1];
                }
            });
        }

        // check the facebook pixel tracking id
        if ( typeof fbq !== 'undefined' ) {
            // wait for fb to do its "thing"(to fix fbq.getState is not a function)
            setTimeout( function () {
                // set the tdAnalytics._fbPixelId property
                tdAnalytics._fbPixelId = fbq.getState().pixels[0].id;
            }, 500);

            // setTimeout( function () {
            //     console.log(tdAnalytics._fbPixelId);
            // }, 160);
        }

        // console.log(tdAnalytics._gaTrackingId);
        // console.log(tdAnalytics._fbPixelId);

        jQuery( 'body' ).on( 'click',
            '.tdm_block_button .tds-button .tdm-btn, ' +
            '.tdm_block_icon_box .tds-button .tdm-btn, ' +
            '.td_block_single_image .td_single_image_bg',
        function(event) {

            event.preventDefault();

            var $this = jQuery(this),
                eventData = {
                    ga: {},
                    fb: {},
                    eventTarget: '',
                    eventTargetAtt: event.target.getAttribute('target')
                };

            if( event.target.classList.contains('tdm-btn-text') ) {
                eventData.eventTarget = event.target.parentElement.getAttribute('href');
            } else {
                eventData.eventTarget = event.target.getAttribute('href');
            }

            if ( $this.data('ga-event-action') !== undefined  ) {
                // @ts-ignore
                eventData.ga.eventAction = $this.data('ga-event-action');
            }

            if ( $this.data('ga-event-cat') !== undefined  ) {
                // @ts-ignore
                eventData.ga.eventCategory = $this.data('ga-event-cat');
            }

            if ( $this.data('ga-event-label') !== undefined  ) {
                // @ts-ignore
                eventData.ga.eventLabel = $this.data('ga-event-label');
            }

            if ( $this.data('fb-event-name') !== undefined  ) {
                // @ts-ignore
                eventData.fb.eventName = $this.data('fb-event-name');
            }

            if ( $this.data('fb-event-content-name') !== undefined  ) {
                // @ts-ignore
                eventData.fb.eventContentName = $this.data('fb-event-content-name');
            }

            tdAnalytics._trackEvent(eventData);

            tdAnalytics._displayErrors();

        });
    },

    _trackEvent: function(tdEvent) {

        //console.log(tdEvent);

        // check for google analytics required fields
        if (typeof tdEvent.ga.eventAction === 'undefined') {
            tdAnalytics._gaErrors.push({
                errorId: 'eventActionError',
                errorMessage: 'Google analytics event action is undefined.'
            });
        }

        if (typeof tdEvent.ga.eventCategory === 'undefined') {
            tdAnalytics._gaErrors.push({
                errorId: 'eventCategory',
                errorMessage: 'Google analytics event category is undefined.'
            });
        }

        // check for google analytics
        if ( ! window[window['GoogleAnalyticsObject'] || 'ga'] ) {
            tdAnalytics._gaErrors.push({
                errorId: 'GoogleAnalyticsPageCode',
                errorMessage: 'Google Analytics code is not loaded on the current page.'
            });
        }

        // check for google analytics tracking id
        if ( tdAnalytics._gaTrackingId === '' ) {
            tdAnalytics._gaErrors.push({
                errorId: 'GoogleAnalyticsTrackingId',
                errorMessage: 'Google Analytics TrackingId is missing on the current page.'
            });
        }
        
        // send the ga track event
        if ( tdAnalytics._gaErrors.length === 0 ) {
            gtag( 'event', tdEvent.ga.eventAction,
                {
                    'event_category': tdEvent.ga.eventCategory,
                    'event_label': tdEvent.ga.eventLabel,
                    'event_callback': function () {
                        console.log(' %c GA Success','color: green; font-weight: bold;');
                    }
                }
            );
        }

        // check for fb pixel events
        if ( typeof window.fbq === 'undefined' ) {
            tdAnalytics._fbErrors.push({
                errorId: 'FacebookPixelPageCode',
                errorMessage: 'Facebook Pixel events code is not loaded on the current page.'
            });
        }

        // check for fb pixel analytics tracking id
        if ( tdAnalytics._fbPixelId === '' ) {
            tdAnalytics._fbErrors.push({
                errorId: 'FacebookPixelTrackingId',
                errorMessage: 'Facebook Pixel TrackingId is missing on the current page.'
            });
        }

        if (typeof tdEvent.fb.eventName === 'undefined') {
            tdAnalytics._fbErrors.push({
                errorId: 'FacebookPixelEventName',
                errorMessage: 'Facebook pixel standard event name is not set ( undefined ).'
            });
        }

        // send the fb pixel track event
        if ( tdAnalytics._fbErrors.length === 0 ) {

            if ( typeof tdEvent.fb.eventContentName !== 'undefined' ){
                fbq( 'track', tdEvent.fb.eventName, {content_name: tdEvent.fb.eventContentName} );
            } else {
                fbq( 'track', tdEvent.fb.eventName );
            }

            console.log(' %c FB track sent','color: green; font-weight: bold;');
        }

        // set a 150ms timeout to redirect 
        // - we need this to allow ga/fb track events to be sent before the page navigates to the new url
        setTimeout( function() {
            if ( tdEvent.eventTargetAtt === '_blank' ) {
                window.open(tdEvent.eventTarget);
            } else {
                window.location = tdEvent.eventTarget;
            }
        }, 150);

    },

    _inIframe: function() {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    },

    _displayErrors: function() {

        if ( tdAnalytics._gaErrors.length > 0 ) {
            while ( tdAnalytics._gaErrors.length > 0 ) {
                var ga_item = tdAnalytics._gaErrors.shift();
                console.warn( ga_item.errorId + ': ' + ga_item.errorMessage );
            }
        }

        if ( tdAnalytics._fbErrors.length > 0 ) {
            while ( tdAnalytics._fbErrors.length > 0 ) {
                var fb_item = tdAnalytics._fbErrors.shift();
                console.warn( fb_item.errorId + ': ' + fb_item.errorMessage );
            }
        }
    }

};

//init analytics
jQuery(window).ready(function() {
    tdAnalytics.init();
});
